// extracted by mini-css-extract-plugin
module.exports = {"cargoContainer":"CargoForm_cargoContainer__31tKC","containerRow":"CargoForm_containerRow__2p79K","divider":"CargoForm_divider__6h9Oh"};